import styled from "styled-components";

export const AboutWrapper = styled.section`
  width: calc(100% - 32px);
  max-width: 62rem;
  margin: 0 auto;
  padding: 0 0 ${({ theme }) => theme.spacing(10)};
  text-align: center;
`;

export const AboutText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.darkGray};
  font-family: ${({ theme }) => theme.fonts.primary}, sans-serif;
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  line-height: 1.5;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    font-size: ${({ theme }) => theme.fontSizes.sm};
  }
`;

export const AboutHighlight = styled.span`
  color: ${({ theme }) => theme.colors.cyan};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;
